import { usernameAndIdMentionsPattern } from '../validation'

export const replaceMentionsWithUsernames = (markdown: string) => {
  return markdown.replace(usernameAndIdMentionsPattern, '@$1')
}
